// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"b172618c","370":"dca4d5df","633":"ea5e9082","696":"d75e5a60","774":"efcf90c5","881":"6d436843","946":"11e963b0"}[chunkId] + ".chunk.js";
};